import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiSun, FiZap, FiStar, FiArrowRight } = FiIcons;

export default function Opportunity() {
  return (
    <section id="opportunity" className="py-16 bg-[#100A06] text-white relative overflow-hidden">
      {/* Subtle organic patterns */}
      <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-[#005b2d]/10 rounded-full blur-[120px] -translate-y-1/2 translate-x-1/2"></div>
      <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-[#ece2c7]/5 rounded-full blur-[100px] translate-y-1/2 -translate-x-1/2"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto text-center mb-20">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <span className="text-[#FFC425] font-black uppercase tracking-[0.3em] text-xs mb-4 block">Join the Movement</span>
            <h3 className="text-4xl md:text-6xl font-extrabold mb-8 leading-[1.1]">
              Be the <span className="text-[#FFC425]">Light</span> <br /> 
              in Someone's Dark.
            </h3>
            <p className="text-xl text-slate-300 mb-12 leading-relaxed max-w-2xl mx-auto font-light">
              Your healing journey is the bridge for someone else. By joining our NeoLife family, you'll gain the mentorship and tools to thrive, while bringing your own unique light and vision to help us transform even more lives.
            </p>
          </motion.div>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-20">
          {[
            { 
              icon: FiSun, 
              title: "Inspire Change", 
              text: "Use your personal transformation to guide those still seeking their own path to health." 
            },
            { 
              icon: FiZap, 
              title: "Build Freedom", 
              text: "Create a sustainable lifestyle that honors your time, your values, and your vision." 
            },
            { 
              icon: FiStar, 
              title: "Direct Access", 
              text: "Work personally with Pete and Rosemary to develop your leadership and wellness expertise." 
            }
          ].map((item, i) => (
            <motion.div 
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="p-10 rounded-[2.5rem] bg-white/5 border border-white/10 backdrop-blur-sm hover:bg-white/10 transition-colors group"
            >
              <div className="w-16 h-16 bg-[#ece2c7] text-[#2A1A0F] rounded-2xl flex items-center justify-center mb-8 shadow-xl shadow-yellow-900/20 group-hover:scale-110 transition-transform">
                <SafeIcon icon={item.icon} className="text-3xl" />
              </div>
              <h4 className="text-xl font-bold mb-4 tracking-tight">{item.title}</h4>
              <p className="text-slate-300 leading-relaxed font-light">{item.text}</p>
            </motion.div>
          ))}
        </div>

        <div className="text-center">
          <a 
            href="https://beta.neolife.com/peteandrosemary/en-US/enrollment"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-4 bg-[#ece2c7] text-[#2A1A0F] px-14 py-6 rounded-full font-black text-lg hover:bg-white transition-all shadow-2xl shadow-black/20 hover:-translate-y-1 active:scale-95 uppercase tracking-widest"
          >
            Join Our Team
            <SafeIcon icon={FiArrowRight} />
          </a>
          <p className="mt-8 text-slate-400 text-xs font-bold uppercase tracking-[0.2em]">
            Global Enrollment Open • Pete & Rosemary NeoLife Team
          </p>
        </div>
      </div>
    </section>
  );
}